/**
 * <strong>Purpose:</strong> <br>
 * Provides ability to manage opening of Menu
 * <br><br>
 * <strong>Contract:</strong> <br>
 *     Should be a container widget
 *
 * @module mw-form/mixins/OnOpenMixin
 *
 * @copyright Copyright 2014-2015 The MathWorks, Inc.
 */

define([
    "dojo/_base/declare",
    "dojo/_base/lang",
    "dojo/dom-geometry"
], function (declare, lang, domGeom) {
    return declare(null, {

        _focusOnOpen: true,
        _matchMinWidthToInvokingWidget: true,

        //From Popup.js
        onOpen: function (best) {
            if (this._defaultContextMenuBlocker) {
                this.domNode.addEventListener("contextmenu", this._defaultContextMenuBlocker, true);
            }
            
            this._correctWrapperBorder();
            // Get behind the Dojo focus onTouchNode listener (dijit/focus - line 115)
            setTimeout(lang.hitch(this, function () {
                //For popupMenuItem, do not give focus
                if (this._focusOnOpen && this.focus) {
                    // IE does not support window.scrollX or window.scrollY,
                    // so use pageXOffset/pageYOffset instead.
                    // https://developer.mozilla.org/en-US/docs/Web/API/Window/scrollX
                    var x = window.pageXOffset, y = window.pageYOffset;
                    this.focus();
                    window.scrollTo(x, y);
                }
            }), 0);
            this._emitOpenEvent();
            this._updateLayout(best);
        },

        /**
         * popup.open() will try to adjust the border styles of the wrapper if the wrapper 
         * needed to be resized to fit the popup within the viewport.
         */
        _correctWrapperBorder: function () {
            var wrapper = this.domNode.parentElement;

            if (wrapper) {
                wrapper.style.border = "";
            }
        },

        _updateLayout: function (best) {
            this._removeAllWidths();
            if (this._matchMinWidthToInvokingWidget) {
                this._updateWidth();
            }
            this._updateHeight(best);
            this._updatePosition(best);
        },

        _removeAllWidths: function () {
            this.domNode.style.width = "";

            this.getChildren().forEach(function (child) {
                child.domNode.style.width = "";
            });
        },

        _updateWidth: function () {
            var menuWidth = this.domNode.offsetWidth;
            var parentElementAdjustment = 0;

            if (this.domNode.parentElement) {
                parentElementAdjustment = domGeom.getMarginBox(this.domNode.parentElement).w - domGeom.getMarginBox(this.domNode).w;
                menuWidth = this.domNode.parentElement.offsetWidth;
            }

            // g2201672, g1284030: If the width of the menu is smaller than the width of the button, then adjust the width
            if (this._invokingWidget && (menuWidth < this._invokingWidget.domNode.offsetWidth)) {
                this.domNode.style.width = (this._invokingWidget.domNode.offsetWidth - parentElementAdjustment) + "px";
            }
        },

        // g1353197: The dijitPopup and the widget are both trying to handle scrollbars in certain
        // circumstances.  We just want one to handle this, so we choose the widget for flexibility.
        _updateHeight: function (best) {
            var pageHeight, content, wrapper, wrapperYOffset, contentComputesStyles, wrapperComputesStyles, borderTotals;

            if (this.domNode &&
                this.domNode.parentElement &&
                this.domNode.parentElement.classList &&
                this.domNode.parentElement.classList.contains("dijitPopup")) {

                content = this.domNode;
                wrapper = content.parentElement;

                var contentComputedStyle = window.getComputedStyle(content);
                if (best && parseInt(contentComputedStyle.height) > best.h) { // if dojo is providing best and menu is overflowing
                    // assuming wraper placed itself correctly and that dojo's best calculation is correct
                    content.style.height = best.h + "px";
                }
                
                // Prevent the dijitPopup from handling scrollbars.
                wrapper.style.overflow = "hidden";
                wrapper.style.overflowX = "hidden";
                wrapper.style.overflowY = "hidden";
            }
        },
        
        _updatePosition: function (best) {
            var adjustment;
            // If the menu opened up to the right of the around node, then we may need to adjust the horizontal position
            if (best &&
                (best.corner.charAt(1) === "L") &&
                (best.aroundCorner.charAt(1) === "R") &&
                (best.overflow)) {
                // We can assume that any overflow is in the horizontal direction since vertical scroll is enabled
                adjustment = parseInt(this.domNode.parentElement.style.left) - best.overflow;
                adjustment = adjustment < 0 ? 0 : adjustment;
                this.domNode.parentElement.style.left = adjustment + "px";
            }
        },

        _setFocusOnOpenAttr: function (/* Boolean */ value) {
            if ((typeof value !== "boolean")) {
                throw new Error("'focusOnOpen' property expects a boolean value.");
            }
            this._set("_focusOnOpen", value);
        },

        _emitOpenEvent: function () {
            this.emit("open", {
            });
        }
    });

});
